import {pushEdapEvent} from '../../utils/edap';

export const ACTION_LOCATION = 'city-descendant-linkpile';

export function pushHandlerClickData(lbsId, position) {
    const eventData = {
        actionlocation: ACTION_LOCATION,
        eventlbsuuid: lbsId,
        eventrefinements: `locality,position:${position}`,
    };

    const fastPathEventData = {
        action_location: ACTION_LOCATION,
        event_lbsuuid: lbsId,
        event_refinements: `locality,position:${position}`,
    };

    return () => {
        pushEdapEvent('content_tile.selected', fastPathEventData);
        pushEdapEvent('destination.link.click', eventData);
    };
}

export function pushHandlerNext() {
    const edapData = {
        actionlocation: ACTION_LOCATION,
    };

    pushEdapEvent('nav.next.click', edapData);
    pushEdapEvent('ux.cards_visible.adjusted', {
        action_location: ACTION_LOCATION,
        event_action: 'next_arrow_clicked',
    });
}

export function pushHandlerPrev() {
    const edapData = {
        actionlocation: ACTION_LOCATION,
    };

    pushEdapEvent('nav.previous.click', edapData);
    pushEdapEvent('ux.cards_visible.adjusted', {
        action_location: ACTION_LOCATION,
        event_action: 'previous_arrow_clicked',
    });
}
